import React, { ChangeEvent, useCallback, useEffect, useState } from "react";
import { Disclosure, Transition } from "@headlessui/react";
import { useSelector } from "react-redux";
import { AppState } from "../../../../../../stateManager/store";
import { store } from "../../../../../../stateManager";
import { UPDATE_STEPS_ORDER } from "../../../../../../stateManager/store/formCreation_v2/types";
import { DndContext, KeyboardSensor, MouseSensor, TouchSensor, useSensor, useSensors } from '@dnd-kit/core';
import { useSortable, SortableContext, verticalListSortingStrategy } from '@dnd-kit/sortable';
import { arrayMove } from '@dnd-kit/sortable';
import { ReactComponent as Down } from "../../../../../../assets/svg/solobuilder/dropdown-down.svg";
import { ReactComponent as Up } from "../../../../../../assets/svg/solobuilder/dropdown-up.svg";
import { ReactComponent as Delete } from "../../../../../../assets/svg/solobuilder/expansion-delete.svg";
import { ReactComponent as Drag } from "../../../../../../assets/svg/drag_icon.svg";
import { Checkbox } from "./AddExpansion";

const WizardStepsExtensionPanel = (props: any) => {

    const ENTER_TITLE = "Enter Title";
    const ENTER_DESCRIPTION = "Enter Description";
    const {
        wizardTitle, wizardDescription, setWizardTitle, setWizardDescription,
        setErrMessage, ErrMessage, handleChangeWizard, removewizardSteps,
    } = props;

    const { selectedElementId, components } = useSelector((state: AppState) => state.formJson);
    const [component, setComponent]:any = useState(components[selectedElementId]);
    const [openStates, setOpenStates] = useState(Array(components[selectedElementId]?.fields?.length).fill(false));
    useEffect(()=>{
        if(components && components[selectedElementId]){
            setComponent(components[selectedElementId]);
            if(openStates?.length < components[selectedElementId]?.fields?.length) {
                let different = components[selectedElementId]?.fields?.length - openStates?.length;
                let openStatesValue = openStates;
                for(let i=1; i<=different; i++) {
                    openStatesValue.push(false);
                }
                setOpenStates(openStatesValue);
            }
        }
    },[components])
    const ellipsisStyle: any = {
        "-webkit-box-orient": "vertical",
        display: "-webkit-box",
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        WebkitLineClamp: '1',
        wordBreak: 'break-word'
    };

    const sensors = useSensors(
        useSensor(MouseSensor),
        useSensor(TouchSensor),
        useSensor(KeyboardSensor)
      );

    const SortableItem = ({ id, open, items, index }: any) => {
        const { attributes, listeners, setNodeRef, transform, transition, setActivatorNodeRef } = useSortable({ id });
        const style = {
            transform: `translateY(${transform?.y}px)`,
            transition,
          };

          const openOrCloseDisclosure = (index: number): any => {
            setOpenStates(prev => 
              prev.map((state, i) => (i === index ? !state : state))
            );
          };


        return (
            <Disclosure.Button style={{
                borderRadius: "4px", height: "28px", marginTop: "10px", background: "#EFF0F4", padding: '10px 8px', marginBottom: '5px', ...style
            }}
                onClick={() => openOrCloseDisclosure(index)}
                ref={setNodeRef}
                className="flex items-center p-2 w-full marginTop_seg justify-between rounded-sm  text-purple-900 hover:bg-purple-200 focus:outline-none focus-visible:ring focus-visible:ring-purple-500 focus-visible:ring-opacity-75"
            >
                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center'}}>
                    <button className="DragHandle" {...attributes} {...listeners} ref={setActivatorNodeRef} style={{ outline: 'none', cursor: 'grab', marginLeft: '4px' }}>
                       <Drag style={{ height: '14px', width: '8px' }}/>
                    </button>
                    <span style={{ ...ellipsisStyle, fontWeight: 600, fontSize: "12px", color: "#505F7B", textAlign: 'left', marginLeft: '8px', lineHeight: 'normal', paddingTop: '3px' }}>{items?.title}</span>
                </div>
                <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                    {component?.fields?.length > 1 && <Delete style={{ cursor: "pointer" }} height="12px" width="12px"
                        onClick={(e) => {
                            removewizardSteps(e, items?.id, selectedElementId)
                        }}
                    />}
                    <div>
                        {
                            open ? <Up height="4px" width="8px"></Up> : <Down height="4px" width="8px"></Down>
                        }
                    </div>
                </div>
            </Disclosure.Button>
        );
    };

    const handleDragEnd = (event: any) => {
        const { active, over, delta } = event;
        if (over !== null) {
            if (active?.id && over?.id && active?.id !== over?.id) {
                const oldIndex = component?.fields.indexOf(active.id);
                const newIndex = component?.fields.indexOf(over.id);
                const afterMoveValue = arrayMove(component?.fields, oldIndex, newIndex);
                store.dispatch({
                    type: UPDATE_STEPS_ORDER,
                    data: {
                        fields: afterMoveValue,
                        selectedElementId: selectedElementId
                    }
                });
            }
        } else {
            store.dispatch({
                type: UPDATE_STEPS_ORDER,
                data: {
                    fields: component?.fields,
                    selectedElementId: selectedElementId
                }
            });
        }
        setOpenStates(prev => 
            prev.map((state, i) => (false))
        );
    };

    return (
        <div className="w-full">
            <div className="w-full bg-transparent steps-list">
                {
                    props.tabAddMode &&
                    <div style={{ display: "flex", gap: "10px", width: "100%", marginTop: "10px" }}>
                        <div style={{ display: "flex", alignItems: "center", gap: "8px", flexDirection: "column", width: "100%" }}>
                            <div className="panel-div">
                                <label	
                                    htmlFor={`Wizard_Step_Title_New`}	
                                    className="panel-label">
                                    Title
                                </label>
                                <input
                                    type={"text"}
                                    id={`Wizard_Step_Title_New`}
                                    className="panel-input"
                                    onChange={(e: ChangeEvent<HTMLInputElement>) => { setWizardTitle(e.target.value); setErrMessage("") }}
                                    value={wizardTitle || ""}
                                    placeholder={ENTER_TITLE}
                                />
                            </div>
                            <div className="panel-div">
                                <label	
                                    htmlFor={`Wizard_Step_Desc_New`}	
                                    className="panel-label">
                                    Description
                                </label>
                                <textarea
                                    id={`Wizard_Step_Desc_New`}
                                    className="panel-textarea panel-input"
                                    maxLength={500}
                                    onChange={(e: any) => {
                                        setWizardDescription(e.target.value); 
                                    }}
                                    value={wizardDescription || ""}
                                    placeholder={ENTER_DESCRIPTION}
                                />
                            </div>
                            <div style={{ width: "100%", textAlign: "end", marginTop: "6px"}}>
                                <p style={{ fontSize: "11px", lineHeight: "14px", color: "#282B31",display: "inline-block", justifyContent: "center"}}>
                                {wizardDescription?.length ? wizardDescription?.length : 0} / 500
                                </p>
                            </div>
                        </div>
                        {ErrMessage && (
                            <p
                                data-test-id="validation_error_message"
                                style={{ color: "red", marginLeft: "6px" }}
                            >
                                {ErrMessage}
                            </p>
                        )}
                    </div>
                }
                <DndContext onDragEnd={handleDragEnd} sensors={sensors}>
                    <SortableContext items={component?.fields} strategy={verticalListSortingStrategy}>
                        {
                            component && component?.fields?.length > 0 && component?.fields?.map((id: any, i: number) => {
                            let items = components[id]
                            return (
                                <div style={{ marginTop: "10px",width:"278px" }}>
                                    <Disclosure>
                                    <>
                                        <SortableItem key={id} id={id} open={openStates[i]} items={items} index={i} />
                                        {openStates[i] && (
                                            <Transition
                                                show={openStates[i]}
                                                enter="transition duration-100 ease-out"
                                                enterFrom="transform scale-95 opacity-0"
                                                enterTo="transform scale-100 opacity-100"
                                                leave="transition duration-75 ease-out"
                                                leaveFrom="transform scale-100 opacity-100"
                                                leaveTo="transform scale-95 opacity-0"
                                            >
                                                <div style={{ border: "1.5px solid #EFF0F4", borderTop: "none", padding: "0px 5px 9px", borderTopLeftRadius: "0px", borderTopRightRadius: "0px", borderBottomRightRadius: "4px", borderBottomLeftRadius: "4px" }}>
                                                    <Disclosure.Panel static>
                                                        <div className="panel-div">
                                                            <label	
                                                                htmlFor={`Wizard_Step_Title_${i}`}	
                                                                className="panel-label">
                                                                Title
                                                            </label>
                                                            <input
                                                                type={"text"}
                                                                id={`Wizard_Step_Title_${i}`}
                                                                className="panel-input"
                                                                placeholder={ENTER_TITLE}
                                                                onChange={(e: ChangeEvent<HTMLInputElement>) => {
                                                                    handleChangeWizard(items?.id, "title", e.target.value)
                                                                }}
                                                            />
                                                        </div>
                                                        <div className="panel-div">
                                                            <label	
                                                                htmlFor={`Wizard_Step_Desc_${i}`}	
                                                                className="panel-label">
                                                                Description
                                                            </label>
                                                            <textarea
                                                                id={`Wizard_Step_Desc_${i}`}
                                                                className="panel-textarea panel-input"
                                                                placeholder={ENTER_DESCRIPTION}
                                                                maxLength={500}
                                                                onChange={(e: ChangeEvent<HTMLTextAreaElement>) => {
                                                                    handleChangeWizard(items?.id, "description", e.target.value);
                                                                }}
                                                                value={items?.description}
                                                            />
                                                        </div>
                                                        <div style={{ width: "100%", textAlign: "end", marginTop: "6px"}}>
                                                            <p style={{ fontSize: "11px", lineHeight: "14px", color: "#282B31",display: "inline-block", justifyContent: "center"}}>
                                                                {items?.description?.length ? items?.description?.length : 0} / 500
                                                            </p>
                                                        </div>
                                                        <Checkbox
                                                            id={`Step_Disable_${i}`}
                                                            checked={items?.properties.config.disable}
                                                            onChange={(changeValue) => {
                                                                handleChangeWizard(items?.id, `properties.config.disable`, changeValue)
                                                            }}
                                                            label="Disable"
                                                        />
                                                    </Disclosure.Panel>
                                                </div>
                                            </Transition>
                                        )}
                                    </>
                                    </Disclosure>
                                </div>
                            )
                            })
                        }
                    </SortableContext>
                </DndContext>
            </div>
        </div>
    )
}

export default WizardStepsExtensionPanel;